import React from 'react';

export const eventDetailsPageTitle = 'Traumatic event details';
export const eventDetailsPrompt =
  'Briefly describe what happened during your traumatic event in the military.';
export const eventDetailsHint =
  'We don’t need to know the names of people that were involved in the traumatic events. If you do share any names, we won’t contact any of those individuals.';
export const eventExamplesAdditionalInfo = (
  <va-additional-info trigger="Examples of responses">
    <div>
      <ul>
        <li>I was a corpsman on a medical ship in a combat area</li>
        <li>I experienced emotional abuse</li>
        <li>I experienced sexual assault</li>
        <li>I was involved in a natural disaster</li>
      </ul>
    </div>
  </va-additional-info>
);
export const eventLocationQuestion = 'Where did the event happen?';
export const eventLocationHint =
  'For example, you can enter, ’Stationed on U.S.S. Repose,’ or ’Fort Knox, Kentucky.’ You can also enter more than one location.';
export const eventTimingQuestion = 'When did the event happen?';
export const eventTimingHint =
  'For example, you can enter, ’Summer of ’70,’ ’June 2007,’ or ’At boot camp.’ Answer as best you can. You don’t have to have an exact date. You can also enter multiple dates or periods of time.';
